import React from 'react';
import Topbar from './Topbar';
import CookieConsentBanner from './CookieConsentBanner';
import Footer from './Footer';
import FloatingRecordButton from './FloatingRecordButton';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--background)', color: 'var(--foreground)' }}>
      <Topbar />
      <main className="pt-16 flex-1">
        {children}
      </main>
      <Footer />
      <CookieConsentBanner />
      <FloatingRecordButton />
    </div>
  );
}